import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ─── Admin Auth ──────────────────────────────────────────

/** Admin login */
export async function adminLogin(credentials) {
  const { data } = await axios.post(`${API}/admin/login`, credentials);
  return data;
}

/** Admin logout */
export async function adminLogout() {
  const { data } = await axios.post(`${API}/admin/logout`, {});
  return data;
}

/** Check admin authentication */
export async function adminGetMe() {
  const { data } = await axios.get(`${API}/admin/me`);
  return data;
}

// ─── Admin Prompts ───────────────────────────────────────

/** Get all admin-editable prompts */
export async function getPrompts() {
  const { data } = await axios.get(`${API}/admin/prompts`);
  return data;
}

/** Update a prompt — accepts full prompt data object */
export async function updatePrompt(promptKey, promptData) {
  const { data } = await axios.put(`${API}/admin/prompts/${promptKey}`, promptData);
  return data;
}

// ─── Analytics Dashboard ─────────────────────────────────

/** Get admin overview stats */
export async function getAdminOverview() {
  const { data } = await axios.get(`${API}/analytics/admin/overview`);
  return data;
}


/** Get detailed info for a specific user */
export async function getAdminUserDetail(userId) {
  const { data } = await axios.get(`${API}/analytics/admin/user/${userId}`);
  return data;
}

/** Get paginated user list */
export async function getAdminUsers(page = 1, limit = 15) {
  const { data } = await axios.get(`${API}/analytics/admin/users?page=${page}&limit=${limit}`);
  return data;
}

/** Get error logs (admin) */
export async function getAdminErrors(unresolvedOnly = false) {
  const { data } = await axios.get(`${API}/analytics/admin/errors?unresolved_only=${unresolvedOnly}`);
  return data;
}

// ─── Health Monitor ───────────────────────────────────────

/** Get full health check (all services with latency) */
export async function getHealthFull() {
  const { data } = await axios.get(`${API}/health/full`);
  return data;
}

/** Get health history (last 24h chart data, incidents, uptime) */
export async function getHealthHistory() {
  const { data } = await axios.get(`${API}/health/history`);
  return data;
}

/** Trigger a manual health check run (admin only) */
export async function triggerHealthRun() {
  const { data } = await axios.post(`${API}/health/run`);
  return data;
}
